import React from 'react';
import { Container } from '../../../types/canvas.types';

type AddNestedVerticalProps = {
    id?: string;
    parentId: string;
    nestedContainers: Container[];
    onAdd: (parentId: string) => void;
    rowContainers?: Container[];
}

export const AddNestedVertical = ({
    id,
    parentId,
    nestedContainers,
    onAdd,
    rowContainers
  }: AddNestedVerticalProps) => {
    const baseId = id || 'add-nested-vertical';
    const containersToCheck = rowContainers || nestedContainers.filter(c => c.configuration.width !== '100%');
    const isMaxContainers = containersToCheck.length >= 3;

    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();

      if (isMaxContainers) {
        console.warn("Maximum of 3 side-by-side containers allowed");
        return;
      }

      onAdd(parentId);
    };

    return (
      <div id={baseId} data-testid={baseId} className={`tw-flex tw-flex-col tw-items-center tw-justify-center tw-group tw-cursor-pointer tw-self-stretch tw-min-h-full ${isMaxContainers ? 'tw-opacity-50' : ''}`}>
        <div id={`${baseId}-line-top`} className="tw-flex-1 tw-min-h-[40px] tw-w-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
        <button
          id={`${baseId}-add-btn`}
          data-testid={`${baseId}-add-btn`}
          className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-transparent tw-text-transparent group-hover:tw-bg-[#1F7AE4] group-hover:tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-none group-hover:tw-shadow-md tw-transition-all tw-duration-200 tw-my-2"
          onClick={handleClick}
          disabled={isMaxContainers}
          title={isMaxContainers ? "Maximum of 3 containers per row reached" : "Add container"}
        >
          <span id={`${baseId}-icon`} className="tw-text-base">+</span>
        </button>
        <div id={`${baseId}-line-bottom`} className="tw-flex-1 tw-min-h-[40px] tw-w-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
      </div>
    );
  };